import React from 'react'
import { Button } from './ButtonUtils'

function BasicButton({ text, ...rest }) {
    return (
        <Button className=" py-2 px-5 rounded-lg bg-red-500 " {...rest}>{text}</Button>
    )
}

export default BasicButton